import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import heroImg from "@/assets/hero/textiel-bedrukken.webp";
import imgZeefdruk from "@/assets/techniques/zeefdruk.webp";
import imgTransfer from "@/assets/techniques/transferdruk.webp";

const TextielBedrukkenPage = () => {
  return (
    <PageLayout
      title="Textiel bedrukken"
      metaDescription="Textiel bedrukken bij Magic Print. Zeefdruk en textieltransfers. Voor elke oplage de juiste techniek."
      ogImage={heroImg}
      hero={
        <PageHero
          image={heroImg}
          alt="Textiel bedrukken bij Magic Print"
          title="Textiel bedrukken"
          subtitle="Zeefdruk en textieltransfers — voor elke oplage de juiste techniek."
        />
      }
    >
      <article className="py-4">

        <p className="text-lg text-muted-foreground mb-4">
          Voor textiel bedrukken kunt u kiezen uit verschillende technieken. Magic Print heeft voor elke opdracht de juiste techniek.
        </p>
        <p className="text-lg text-muted-foreground mb-4">
          Voor grotere oplages (vanaf 25 stuks) is het drukken met zeefdruk vaak de voordeligste keuze.
        </p>
        <p className="text-lg text-muted-foreground mb-10">
          Als u een kleinere oplage nodig heeft (vanaf 10 stuks) wordt vaak gebruik gemaakt van Dtf transfers.
        </p>

        <section className="mb-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-[#0a2933] mb-4">Zeefdrukken</h2>
            <p className="mb-4 text-muted-foreground">
              Bij de zeefdruk techniek heeft uw bedrukking een mooie kleur en vormt het inkt zich naar de stof. De bedrukking is ook beter bestand tegen slijtage en zal dus langer meegaan. Vrijwel alles is te bedrukken met deze techniek, het enige vereiste is dat het een plat oppervlak betreft.
            </p>
            <p className="text-muted-foreground">
              U kunt bij Magic Print vrijwel elke afbeelding, logo of tekst op textiel laten bedrukken. Wij hebben hiervoor een breed assortiment van verschillende textielproducten zoals shirts, truien of petjes scherp voor u ingekocht. Door gebruik te maken van onze producten geniet u dus van lagere prijzen en weet u zeker dat u kwalitatief goede producten zult ontvangen.
            </p>
          </div>
          <img
            src={imgZeefdruk}
            alt="Zeefdruk proces"
            className="rounded-lg w-full h-auto"
            loading="lazy"
          />
        </section>

        <section className="mb-12 grid md:grid-cols-2 gap-8 items-center">
          <img
            src={imgTransfer}
            alt="Textieltransfer machine"
            className="rounded-lg w-full h-auto md:order-1"
            loading="lazy"
          />
          <div className="md:order-2">
            <h2 className="text-3xl font-bold text-[#0a2933] mb-4">Textieltransfers</h2>
            <p className="text-muted-foreground">
              Wij maken gebruik van professionele solvent printers om de beste textieltransfers te kunnen maken. De transfers worden door Magic Print behandeld met een speciale coating, hierdoor kunt u uw bedrukking gewoon tot <strong>90 graden</strong> in de wasmachine wassen en zal de bedrukking tot wel <strong>200 wasbeurten</strong> goed blijven op het textiel.
            </p>
          </div>
        </section>

        <section className="mb-12 bg-[#fcfcfc] border border-border rounded-lg p-6">
          <h3 className="text-2xl font-bold text-[#0a2933] mb-3">Wij leveren alle producten om voor u te bedrukken of te borduren!</h3>
          <p className="text-muted-foreground">
            Wij kunnen u een enorm assortiment aan artikelen aanbieden, u kunt deze vinden onder producten. Doordat wij groot inkopen kunt u zo profiteren van extra scherpe prijzen en de beste kwaliteit. Wilt u toch een eigen kledingstuk aanleveren? Geen punt, u bent bij ons niets verplicht.
          </p>
        </section>

        <section className="mb-12">
          <h3 className="text-2xl font-bold text-[#0a2933] mb-4">Voordelen van textiel bedrukken met zeefdruk</h3>
          <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
            <li>Erg duurzaam, tot wel 200 wasbeurten op 90 graden in de wasmachine te wassen.</li>
            <li>Tot wel 6 kleuren drukken al vanaf een afname 25 stuks.</li>
            <li>Uw eigen logo of afbeelding full color laten bedrukken.</li>
            <li>Mogelijk voor elk (vlak) oppervlak.</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-3xl font-bold text-[#0a2933] mb-4">Wij gebruiken onze druktechnieken voor o.a:</h2>
          <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
            <li>Bedrijfskleding bedrukken</li>
            <li>Werkkleding bedrukken</li>
            <li><a className="text-[#059594] hover:underline" href="/t-shirt-bedrukken">T-shirt bedrukken</a></li>
            <li>Polo's bedrukken</li>
            <li>Sweaters bedrukken</li>
            <li>Hoodies bedrukken</li>
            <li>Sportkleding bedrukken</li>
            <li>Caps bedrukken</li>
          </ul>
        </section>

        <section className="mb-12">
          <p className="text-muted-foreground">
            Het aanschaffen van bedrijfskleding is fiscaal aftrekbaar. De belastingdienst stelt dat, als er min. 70 cm² van de kleding is geborduurd met bedrijfsnaam en/of logo, de kosten ten laste kunnen komen van uw bedrijf. Een oppervlakte van 70 cm² komt in de praktijk meestal overeen met 2 logo's. Bijvoorbeeld een borst- en een ruglogo.
          </p>
        </section>
      </article>
    </PageLayout>
  );
};

export default TextielBedrukkenPage;
